import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import AuthLayout from '@SiteContainers/AuthLayout'

import {
  ssoSignIn,
} from '@SiteModules/Authentication/actions'

import './UsersSignIn.scss'

const UsersSignIn: React.FC = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const ssoDomain = urlParams.get('ssoDomain')

    if (ssoDomain) {
      dispatch(ssoSignIn({ emailOrDomain: ssoDomain }))
    }
  }, [])

  return (
    <div className="UsersSignIn">
      <AuthLayout initialScreen={'signin'}/>
    </div>
  )
}

export default UsersSignIn
